import { memo } from 'react';

import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IKnmFormDocumentCommon } from 'KnmPackage/MainModule/interfaces/IKnmFormDocumentCommon';
import { useKnmDocumentAttachment } from 'KnmPackage/MainModule/hooks/useKnmDocumentAttachment';
import { UploadFile } from 'UIPackage/MainModule/components/UploadFile';
import { Hint } from 'CorePackage/MainModule/components/Hint';

import styles from './ErknmActExtract.module.scss';

interface IErknmActExtractProps {
  extract: IKnmFormDocumentCommon | undefined;
  withoutMarginTop?: boolean;
}

export const ErknmActExtract = memo(({ extract, withoutMarginTop }: IErknmActExtractProps) => {
  const { downloadKnmDocumentAttachment } = useKnmDocumentAttachment();

  const downloadAttachment = () => {
    if (!extract || extract.attachments?.length === 0) return null;

    const attachment = extract.attachments?.[0];

    if (!attachment) return null;

    const { fileName, fileSize } = attachment;
    const filePath = attachment.filePath || null;
    const mimeType = attachment.mimeType || null;

    downloadKnmDocumentAttachment({ fileName, filePath, fileSize, mimeType });
  };

  return (
    <div className={withoutMarginTop ? styles.WrapperWithoutMarginTop : styles.Wrapper}>
      <FieldBlock label={'Выписка'}>
        <div className={styles.ActDocument}>
          <div className={styles.InfoBlock}>
            {extract && (
              <FieldBlock
                label={'Файл выписки'}
                color="black"
                placementLabel="left"
                type="not-space"
                className={styles.FieldBlock}
              >
                <UploadFile
                  fileName={extract.attachments?.[0]?.fileName || ''}
                  fileSize={extract.attachments?.[0]?.fileSize || 0}
                  onFileNameClick={downloadAttachment}
                />
              </FieldBlock>
            )}
            {!extract && <Hint text="Формируется автоматически после подписания акта" />}
          </div>
        </div>
      </FieldBlock>
    </div>
  );
});
